export default "__VITE_ASSET__3408297d__"